import { ROUTES } from "../../../../module/constants";
import { generalConst } from "../../../../module/globalInterface";

export const EXTERNAL_PORTAL_MGMT_CONSOLE_ADMIN_URLS: generalConst = {
  BASE_URL: ROUTES.ADMIN_EXTERNAL_PORTAL_MGMT,
  CONFIGURATIONS: `${ROUTES.ADMIN_EXTERNAL_PORTAL_MGMT}/configurations`,
  USERS_OPERATIONS_CONFIGURATIONS: `${ROUTES.ADMIN_EXTERNAL_PORTAL_MGMT}/usersOperationsConfigurations`,
};

export const STATE_IDENTIFIER = {
  CONFIGURATIONS: "configurations",
  OFFICES: "offices",
  SOCIETIES: "societies",
  ORGANIZATIONAL_UNITS: "organizationalUnits",
  ATTRIBUTES: "attributes",
  COUNTERS: "counters",
  USERS_OPERATIONS_CONFIGURATIONS: "usersOperationsConfigurations",
  REQUEST_STATE: "requestState",
  OU_ENRICHMENTS: "ouEnrichments",
  ROLES: "roles",
  SELECTED_ROLE: "selectedRole",
  BUTTONS: "buttons",
  FIELD_VISIBILITY: "fieldVisibility",
};

export const LIST_IDENTIFIER: string = "list";
export const LOADER_IDENTIFIER: string = "loader";

export enum selectOperationsValue {
  CREATE = "create",
  USER = "user",
  RENEW = "renew",
}

export enum selectOperationsFirstLetter {
  CREATE = "C",
  USER = "U",
  RENEW = "R",
}

export enum externalPortalToggleFieldsButtonVisibility {
  ADD_USER = "1",
  REPORT = "2",
  MASSIVE_ADD = "3",
  TERMINATE_CONSULTANT = "4",
  REACTIVATE_CONSULTANT = "5",
  ADMIN_LETTER = "6",
  DISABLE_USER = "7",
  RENEW_USER = "8",
  TERMINATE_SECURITY = "9",
  REACTIVATE_ADMIN = "10",
  RENEW_ADMIN = "11",
  TERMINATE_OUTSOURCER = "12",
  REACTIVATE_OUTSOURCER = "13",
  AD_USER_REQUEST = "14",
  EMAIL_NEXI_EMAIL_REQUEST = "15",
  WIFI_NEXI_EXT_WIFI_REQUEST = "16",
  ATTACHMENTS = "17",
  CHANGE_PROFILE = "18",
  BADGE_REQUEST = "19",
  BLOCKED_SECURITY = "20",
  VALIDATE_USER = "21",
}

export enum operationLetterIdentifier {
  HIDDEN = "H",
  OBSCURED = "O",
  READ_ONLY = "R",
  WRITE = "W",
  BYPASS = "B",
  MANDATORY = "M",
}
